import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import { colors } from '@/shared/design-system/tokens';

const challengersCreaseTheme = {
  dark: true,
  colors: {
    background: colors.bg.primary,
    surface: colors.bg.surface,
    'surface-bright': colors.bg.elevated,
    'surface-light': colors.bg.secondary,
    'surface-variant': colors.slate[800],
    'on-surface-variant': colors.text.body,
    primary: colors.primary,
    'on-primary': colors.text.onPrimary,
    secondary: colors.cyan,
    'on-secondary': colors.text.onPrimary,
    accent: colors.cyanAlt,
    error: colors.danger,
    info: colors.cyanLink,
    success: colors.success,
    warning: colors.warning,
    'on-background': colors.text.body,
    'on-surface': colors.text.body,
  },
  variables: {
    'border-color': colors.border.default,
    'border-opacity': 1,
    'high-emphasis-opacity': 1,
    'medium-emphasis-opacity': 0.85,
    'disabled-opacity': 0.4,
  },
};

export const vuetify = createVuetify({
  theme: {
    defaultTheme: 'challengersCrease',
    themes: { challengersCrease: challengersCreaseTheme },
  },
  defaults: {
    VBtn: {
      style: 'text-transform: none; letter-spacing: 0.02em; font-weight: 600;',
      rounded: 'lg',
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
    },
    VTextarea: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
    },
    VCard: {
      rounded: 'xl',
    },
    VChip: {
      rounded: 'pill',
    },
  },
  icons: { defaultSet: 'mdi', aliases, sets: { mdi } },
});
